import React, { useEffect } from "react";

import PagoDeCita from "./PagoDeCita";

export default () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <PagoDeCita />;
};
